import { FormItem } from '../../../../../commons/Form/Form.types';
import { RegisterEntityStepFormSchema } from './RegisterEntityStepForm.types';

export const registerEntityStepData: FormItem<RegisterEntityStepFormSchema>[][] = [
  [
    {
      name: 'name',
      placeholder: 'Votre entité...',
      label: "Nom de l'entité",
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'address',
      placeholder: 'Votre adresse...',
      label: 'Adresse',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'city',
      placeholder: 'Votre ville...',
      label: 'Ville',
      type: 'text',
      required: true,
    },
    {
      name: 'postalCode',
      placeholder: 'Votre code postal...',
      label: 'Code postal',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'department',
      placeholder: 'Votre département...',
      label: 'Département',
      type: 'text',
      required: true,
    },
    {
      name: 'region',
      placeholder: 'Votre région...',
      label: 'Région',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'siret',
      placeholder: 'Numéro siret...',
      label: 'Siret',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'firstName_owner',
      placeholder: 'Prénom...',
      label: 'Prénom du représentant légal',
      type: 'text',
      required: true,
    },
    {
      name: 'lastName_owner',
      placeholder: 'Nom...',
      label: 'Nom du représentant légal',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'email_owner',
      placeholder: 'Email...',
      label: 'Email générique',
      type: 'text',
      required: true,
    },
    {
      name: 'phone_owner',
      placeholder: 'N° de téléphone...',
      label: 'N° de téléphone standard',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'function_owner',
      placeholder: 'Fonction...',
      label: 'Fonction du représentant légal',
      type: 'text',
      required: true,
    },
  ],
];
